import i18n from 'utils/i18n'
import { bookingOptions } from 'utils/constants/booking-constants'
import { constantsActive } from 'utils/constants/constants'

export const timeslotGroupForTitle = ( _bookForOption, _timeslotGroup ) => {
	let subtitle = null;
	
	switch( _bookForOption ) {
		case bookingOptions.MYSELF:
			subtitle = i18n.t('page.create.option.options.myself');
			break;
			
		case bookingOptions.MYSELF_AND_COWORKERS:
			switch( true ) {
				case _timeslotGroup.can_book_for_self === constantsActive.YES && _timeslotGroup.can_book_for_coworkers === constantsActive.YES && _timeslotGroup.can_book_for_external === constantsActive.YES:
					subtitle = i18n.t( 'page.create.option.options.myself_and_coworkers_and_externals' );
					break;
					
				case _timeslotGroup.can_book_for_self === constantsActive.YES && _timeslotGroup.can_book_for_coworkers === constantsActive.YES && _timeslotGroup.can_book_for_external === constantsActive.NO:
					subtitle = i18n.t( 'page.create.option.options.myself_and_coworkers' );
					break;
					
				case _timeslotGroup.can_book_for_self === constantsActive.YES && _timeslotGroup.can_book_for_coworkers === constantsActive.NO && _timeslotGroup.can_book_for_external === constantsActive.YES:
					subtitle = i18n.t( 'page.create.option.options.myself_and_externals' );
					break;
			}
			break;
			
		case bookingOptions.COWORKERS:
			switch( true ) {
				case _timeslotGroup.can_book_for_coworkers === constantsActive.YES && _timeslotGroup.can_book_for_external === constantsActive.YES:
					subtitle = i18n.t( 'page.create.option.options.coworkers_and_externals' );
					break;
					
				case _timeslotGroup.can_book_for_coworkers === constantsActive.YES && _timeslotGroup.can_book_for_external === constantsActive.NO:
					subtitle = i18n.t( 'page.create.option.options.coworkers' );
					break;
					
				case _timeslotGroup.can_book_for_coworkers === constantsActive.NO && _timeslotGroup.can_book_for_external === constantsActive.YES:
					subtitle = i18n.t( 'page.create.option.options.externals' );
					break;
			}
			break;
	}
	
	return subtitle;
}
